// extracted by mini-css-extract-plugin
module.exports = {"loadingPageWrap":"styles_loadingPageWrap__3DIsP","loadingPageIcon":"styles_loadingPageIcon__3jfqq"};